export default {
  computed: {
    loading: {
      get() {
        return this.$store.state.app.loading
      },
      set(payload) {
        this.$store.dispatch('app/setLoading', payload)
      },
    },
  },
}
